/// <reference path="../commonClasses/common.interface.ts" />
/// <reference path="../commonClasses/commonDataServiceBase.ts" />
///<reference path="../../plugins/businessInfo/businessInfo.interfaces.ts"/>


module Meevo.Components.Common {
  import IBusinessInfoSettings = Meevo.Plugins.BusinessInfo.IBusinessInfoSettings;

  export interface IBusinessInfoDataService extends  Meevo.Components.CommonClasses.ICommonDataService {
      getBusinessInfoPreferences(options?: IBusInfoRequestOptions): ng.IPromise<IBusinessInfoSettings>;
      getAppointmentBookIncrementInMinutes(appointmentBookPrecisionIncrement: Meevo.Model.AppointmentIncrementEnum): number;
  }

  interface IBusInfoRequestOptions {
      force?: boolean;
      settingName?: string;
  }

    export class BusinessInfoDataService extends Meevo.Components.CommonClasses.CommonDataServiceBase implements IBusinessInfoDataService {
    static businessInfoPreferences: IBusinessInfoSettings;

    get businessInfoPreferences(): IBusinessInfoSettings {
        return BusinessInfoDataService.businessInfoPreferences;
    }

    get endOfTheLastWeekMoment(): moment.Moment {
        return angular.copy(this._endOfTheLastWeekMoment);
    }

    get startOfTheLastWeekMoment(): moment.Moment {
        return angular.copy(this._startOfTheLastWeekMoment);
    }

    get endOfTheWeekMoment(): moment.Moment {
        return angular.copy(this._endOfTheWeekMoment);
    }

    get startOfTheWeekMoment(): moment.Moment {
        return angular.copy(this._startOfTheWeekMoment);
    }
    //TODO: extend DataServiceGenerated

    private _startOfTheWeekMoment: moment.Moment;
    private _endOfTheWeekMoment: moment.Moment;
    private _startOfTheLastWeekMoment: moment.Moment;
    private _endOfTheLastWeekMoment: moment.Moment;

    private businessInfoPreferencesPromise: ng.IDeferred<IBusinessInfoSettings>;

    constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                protected $http: angular.IHttpService,
                protected $q: ng.IQService) {
      super(appSettings, $http);

      this.getBusinessInfoPreferences({force: true});
    }

    getBusinessInfoPreferences(options: IBusInfoRequestOptions = <IBusInfoRequestOptions>{}): ng.IPromise<IBusinessInfoSettings> {
        if(!options.force && typeof BusinessInfoDataService.businessInfoPreferences === 'object') {
            return this.$q.resolve(BusinessInfoDataService.businessInfoPreferences);
        }

        if(this.businessInfoPreferencesPromise && (<any>this.businessInfoPreferencesPromise.promise).$$state.status === 0) {
            return this.businessInfoPreferencesPromise.promise;
        }

        this.businessInfoPreferencesPromise = this.$q.defer();

        this.customMethodData('api/Tenant/BusinessInfo/Settings', 'GET', null)
            .then(response => {
                BusinessInfoDataService.businessInfoPreferences = Object.freeze(response.data);
                this.updateDefaults();

                this.businessInfoPreferencesPromise.resolve(BusinessInfoDataService.businessInfoPreferences);
            });

        return this.businessInfoPreferencesPromise.promise;
    }

    preProcess(entity: any): void {
        var businessInfo = <Model.BusinessInfo>entity;

        if (businessInfo.businessHours == null) return;

        // Need to ensure that date string values are in the supported format
        businessInfo.businessHours.forEach(bh => {
            if (bh.isEnabled) {
                var sTime = new Date(bh.startTime);
                bh.startTime = moment(sTime.getHours() + ":" + sTime.getMinutes(), "h:m a").format();
                var eTime = new Date(bh.endTime);
                bh.endTime = moment(eTime.getHours() + ":" + eTime.getMinutes(), "h:m a").format();
            }
        });
    }

    getAppointmentBookIncrementInMinutes(appointmentBookPrecisionIncrement: Meevo.Model.AppointmentIncrementEnum): number {
        let increment = 15;
        switch (appointmentBookPrecisionIncrement) {
            case Meevo.Model.AppointmentIncrementEnum.Min5:
                increment = 5;
                break;
            case Meevo.Model.AppointmentIncrementEnum.Min10:
                increment = 10;
                break;
        }
        return (increment);
    }

    updateDefaults() {
        const today = moment();
        const appointmentBookSettings = BusinessInfoDataService.businessInfoPreferences.appointmentBookSettings;

        const weekStart = Model.WeekdayNameEnum[appointmentBookSettings.startAppointmentBookDayOn];
        if (moment(today).day(weekStart).toDate() <= today.toDate()) {
            this._startOfTheWeekMoment = moment(today).day(weekStart);
        } else {
            this._startOfTheWeekMoment = moment(today).day(weekStart).add(-7, 'days');
        }

        this._endOfTheWeekMoment = this.startOfTheWeekMoment.add(6, "days");

        this._endOfTheLastWeekMoment = this.startOfTheWeekMoment.subtract(1, "days");
        this._startOfTheLastWeekMoment = this.endOfTheLastWeekMoment.subtract(6, "days");
    }

    static factory(): Function {
      let svc = (appSettings: Meevo.Components.Common.IAppSettings,
                 $http: ng.IHttpService,
                 $q: ng.IQService) => {
        return new BusinessInfoDataService(appSettings, $http, $q);
      };

      svc.$inject = ["meevo.AppSettings", "$http", "$q"];
      return svc;
    }
  }

  angular.module("meevo.components.common")
    .factory("meevo.components.common.BusinessInfoDataService", BusinessInfoDataService.factory());
}
